const styles = (theme) => ({
  root: {
    display: "inline-block",
    float: "right",
  },
  counterDisabled: {
    color: theme.hv.palette.atmosphere.atmo5,
  },
  overloaded: {
    color: theme.hv.palette.semantic.sema4,
  },
  gutter: {
    paddingLeft: `6px`,
  },
});

export default styles;
